import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import {
  FaMicrophoneAlt,
  FaTshirt,
  FaShieldAlt,
  FaExclamationCircle,
} from "react-icons/fa";
import { PiDetective } from "react-icons/pi";
import { BsRobot } from "react-icons/bs";
import { MdDevices } from "react-icons/md";
import { FaLock } from "react-icons/fa6";
import aboutbanner from "../Images/aboutbanner.jpg";
import underline from "../Images/underline.png";
import arr_down from "../Images/arr_down.svg";

const About = () => {
  return (
    <div>
      <Header />
      <section
        className="relative py-40 text-white"
        style={{
          backgroundImage: `url(${aboutbanner})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        }}
      >
        <div className="container mx-auto px-4 relative max-w-xl">
          <div className=" backdrop-blur-sm bg-black-50/30 rounded-md p-8 shadow-lg">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-sans">What We Stand For</h1>
              <h2 className="mt-4 text-lg italic font-normal">
                "At the heart of innovation and trust, we build solutions that
                redefine the future."
              </h2>
            </div>
          </div>
        </div>
      </section>

      <section id="services" data-aos="fade-up">
        <div className="bg-transparent mt-12 flex flex-col items-center text-center w-full mx-auto">
          <h1 className="text-2xl md:text-4xl tracking-tight m-0">
            Who We Are and What We Stand For
          </h1>
          <p className="text-lg text-gray-700 m-0 px-4 mt-2">
            Our commitment lies in empowering individuals and businesses through
            cutting-edge technology and a passion for excellence.
          </p>
        </div>
        <div className="py-8 mx-auto max-w-screen-2xl sm:py-16 lg:px-0">
          <div className="flex flex-col items-center space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Mission</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  To deliver world-class solutions that empower businesses and
                  individuals to achieve their goals effortlessly.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Vision</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  To be a global leader in technological innovation and set new
                  standards of excellence.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Values</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  We believe in transparency, integrity, and putting our clients
                  at the center of everything we do.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Why Choose Us</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  Our team of experts ensures seamless delivery, personalized
                  support, and solutions tailored to your needs
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Expertise</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  From AI-powered tools to dynamic web solutions, we have a
                  diverse range of expertise to transform your ideas into
                  reality.
                </p>
              </div>

              <div
                className="bg-transparent p-6 rounded-lg border-2 border-primary-500"
                data-aos="slide-up"
              >
                <h4 className="mb-2 text-xl font-bold">Our Journey</h4>
                <div className="mb-2">
                  <img
                    src={underline}
                    alt="Underline"
                    className="w-18 h-1.5 mt-3"
                  />
                </div>
                <p className="text-gray-500">
                  With years of experience and countless success stories, we are
                  constantly evolving to meet your challenges.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 bg-gray-100" data-aos="fade-up">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-semibold mb-8 text-center">
            Our Advanced Capabilities
          </h2>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <PiDetective size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Real-Time Monitoring
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <BsRobot size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">AI-Powered Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaMicrophoneAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Voice Analysis</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <MdDevices size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Multi-Device Detection
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaShieldAlt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Secure Administration
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaExclamationCircle size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Suspicious Activity Alerts
              </span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaLock size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">Data Encryption</span>
            </div>
            <div className="flex items-center justify-center p-4 bg-white rounded-md shadow-md mb-4">
              <FaTshirt size={32} className="text-slate-400 mr-2" />
              <span className="text-lg font-semibold">
                Role Based Privileges
              </span>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-transparent mt-12 flex flex-col items-center text-center w-full mx-auto">
        <h1 className="text-2xl md:text-4xl tracking-tight m-0 font-semibold">
          Frequently Asked Questions
        </h1>
      </div>
      <section
        className="px-1 md:px-2 pb-8 pt-10 flex justify-between flex-col md:flex-row max-w-screen-2xl mx-auto"
        data-aos="fade-up"
      >
        <div className="w-full mt-1 md:mt-4">
          <details className="border border-[#F2F4F5] rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7 ">
              What services do you provide?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              We specialize in web and app development, AI-driven solutions, and
              UI/UX design tailored to your unique needs.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              What industries do you serve?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Our solutions are versatile, serving industries like e-commerce,
              healthcare, education, and more.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How do we ensure project success?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Through detailed planning, transparent communication, and
              milestone-based progress tracking, we ensure on-time and
              top-quality delivery.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              How can I get started with your services?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Simply reach out through our contact page, and our team will guide
              you through the onboarding process.
            </p>
          </details>
          <details className="border border-slate-200 rounded-md py-8 px-3 relative open:shadow-lg mb-1 bg-gray-100 duration-300">
            <summary className="list-none font-semibold relative text-lg cursor-pointer pr-7">
              When do I reset a password ?
              <div className="absolute top-0 right-0 rounded-full px-1 py-0.5 cursor-pointer visible open:invisible">
                <div className="p-1 border border-black rounded-full ">
                  <img src={arr_down} alt="" className="h-4 w-4" />
                </div>
              </div>
            </summary>
            <p className="text-md pt-3">
              Yes, in order to use My Page, you must allow the use of cookies in
              your browser.
              <br />
              <br />
              See also: What is a cookie and what does it do?
            </p>
          </details>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
